import { EntryItem } from '@com-delta-omnichannel/aura';
import { ActivityNullValueMocks } from './activity-null-state-value.mocks';

export const ActivityNullStateMocks: EntryItem[] = [
  {
    content: {
      title: 'Flights',
      subtitle: ''
    },
    state: '',
    icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/tracker/mqd-summary/delta-flights-solid.svg',
    value: ActivityNullValueMocks,
    border: 'none',
    ariaLabel: {
      icon: 'Flights logo'
    }
  },
  {
    content: {
      title: 'MQD Boost',
      subtitle: ''
    },
    action: {
      label: 'Earn with a Delta Amex Card',
      url: 'https://creditcard.delta.com/d/delta/'
    },
    state: '',
    icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-platinum-card.svg',
    value: ActivityNullValueMocks,
    border: 'none',
    ariaLabel: {
      icon: 'Amex MQDs logo'
    }
  },
  {
    content: {
      title: 'Delta Rental Cards',
      subtitle: ''
    },
    state: '',
    icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/tracker/mqd-summary/delta-rental-car-solid.svg',
    value: ActivityNullValueMocks,
    border: 'none',
    ariaLabel: {
      icon: 'Delta Rental Cards logo'
    }
  },
  {
    content: {
      title: 'Delta Stays',
      subtitle: ''
    },
    state: '',
    icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/tracker/mqd-summary/delta-stays-solid.svg',
    value: ActivityNullValueMocks,
    border: 'none',
    ariaLabel: {
      icon: 'Delta Stays logo'
    }
  },
  {
    content: {
      title: 'Delta Vacations',
      subtitle: ''
    },
    state: '',
    icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/tracker/mqd-summary/delta-vacations-solid.svg',
    value: ActivityNullValueMocks,
    border: 'none',
    ariaLabel: {
      icon: 'Delta Vacations logo'
    }
  },
  {
    content: {
      title: 'Other',
      subtitle: ''
    },
    state: '',
    icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/tracker/mqd-summary/other-mqd-solid.svg',
    value: ActivityNullValueMocks,
    border: 'none',
    ariaLabel: {
      icon: 'Other logo'
    }
  }
];
